module.exports = __webpack_public_path__ + "img/0405-delete.2f6942c8.svg";